import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import MainRoute from "./Routing/index";
import AdminRoute from "./Components/AdminModule";
import Loader from "./Components/Loader/Loader";
import UserRoute from "./Components/UserModule";

const AppRoutes = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <Loader fullscreen />; // show loader while checking user
  }

  return (
    <Router basename={process.env.PUBLIC_URL}>
      {!user && <MainRoute />}

      {user && user?.role?.id === 1 && <AdminRoute />}

      {user && user?.role?.id !== 1 && <UserRoute />}
    </Router>
  );
};

export default AppRoutes;
